/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Auto_Save_DescInputs */

const en_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable automatic saving to prevent work loss. This will overwrite your current file at specified intervals.`)
};

const fr_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer l'enregistrement automatique pour éviter les pertes. Cela remplacera votre fichier actuel à intervalles définis.`)
};

const de_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivieren Sie die automatische Speicherung, um Datenverlust zu vermeiden. Ihre aktuelle Datei wird dadurch in festgelegten Abständen überschrieben.`)
};

const it_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita il salvataggio automatico per evitare la perdita di dati. Questo sovrascriverà il file corrente a intervalli specificati.`)
};

const ru_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включите автоматическое сохранение, чтобы предотвратить потерю данных. Это позволит перезаписывать текущий файл через заданные интервалы времени.`)
};

const es_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilite el guardado automático para evitar la pérdida de trabajo. Esto sobrescribirá su archivo actual a intervalos específicos.`)
};

const zh_cn2_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用自动保存功能以防止工作丢失。此功能会按指定时间间隔覆盖当前文件。`)
};

const ja_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業内容の損失を防ぐため、自動保存を有効にしてください。これにより、指定した間隔で現在のファイルが上書きされます。`)
};

const hi_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य हानि से बचने के लिए स्वचालित सेविंग चालू करें। इससे आपकी वर्तमान फ़ाइल निर्दिष्ट अंतराल पर ओवरराइट हो जाएगी।`)
};

const pt_pt2_options_backup_auto_save_desc = /** @type {(inputs: Options_Backup_Auto_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ative o salvamento automático para evitar a perda de trabalho. Isso sobrescreverá seu arquivo atual em intervalos especificados.`)
};

/**
* | output |
* | --- |
* | "Enable automatic saving to prevent work loss. This will overwrite your current file at specified intervals." |
*
* @param {Options_Backup_Auto_Save_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_auto_save_desc = /** @type {((inputs?: Options_Backup_Auto_Save_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Auto_Save_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_auto_save_desc(inputs)
	if (locale === "de") return de_options_backup_auto_save_desc(inputs)
	if (locale === "it") return it_options_backup_auto_save_desc(inputs)
	if (locale === "ru") return ru_options_backup_auto_save_desc(inputs)
	if (locale === "es") return es_options_backup_auto_save_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_auto_save_desc(inputs)
	if (locale === "ja") return ja_options_backup_auto_save_desc(inputs)
	if (locale === "hi") return hi_options_backup_auto_save_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_auto_save_desc(inputs)
	return en_options_backup_auto_save_desc(inputs)
});